import React from 'react'

import { timeZoneLabel, formatUtc, formatInZone } from '../utils/saleTime'
import '../styles/UtcAndLocalTime.css'

// Shows the real UTC hour, with the hour in the machine's time zone below it (sale and rental lists).
// Spans instead of divs so it can also go inside a <p> (PropertyLabel).
export default function UtcAndLocalTime({ date, timeZone, warning }) {
  if (!date || isNaN(date.getTime())) return null

  return (
    <span className="utc-local-time">
      <span className="d-block">
        {formatUtc(date)}
        <span className="badge badge-secondary ml-1">UTC</span>
      </span>
      <span className="d-block text-muted">
        {formatInZone(date, timeZone)}
        <span className="badge badge-info ml-1" title={timeZone}>{timeZoneLabel(timeZone)}</span>
        {warning && <i className="fas fa-exclamation-triangle text-warning ml-1" title={warning}></i>}
      </span>
    </span>
  )
}
